/**
 * CENTRALIZED DOMICILIATION PERMISSIONS REDUCER
 * 
 * Redux reducer for managing domiciliation permissions state
 */

import {
  CHECK_DOMICILIATION_PERMISSION_REQUEST,
  CHECK_DOMICILIATION_PERMISSION_SUCCESS,
  CHECK_DOMICILIATION_PERMISSION_FAILURE,
  CLEAR_DOMICILIATION_PERMISSION
} from '../actions/domiciliationPermissionsActions';

const initialState = {
  canView: false,
  userType: null,
  isLoading: false,
  error: null,
  hasChecked: false,
  hasToken: false
};

export default function domiciliationPermissionsReducer(state = initialState, action) {
  switch (action.type) {
    case CHECK_DOMICILIATION_PERMISSION_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        hasToken: action.payload.specialToken
      };

    case CHECK_DOMICILIATION_PERMISSION_SUCCESS:
      return {
        ...state,
        canView: action.payload.canView,
        userType: action.payload.userType,
        isLoading: false,
        error: null,
        hasChecked: true,
        hasToken: action.payload.hasToken
      };

    case CHECK_DOMICILIATION_PERMISSION_FAILURE:
      return {
        ...state,
        canView: false,
        isLoading: false,
        error: action.payload.error,
        hasChecked: true,
        hasToken: action.payload.hasToken
      };

    case CLEAR_DOMICILIATION_PERMISSION:
      return initialState;

    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/domiciliationPermissionsReducer.js